export const tr = {
    'date-placeholder': 'gg.aa.yyyy',
    'number-set-placeholder': 'değer, başka değer, ...',
    'your-value': 'değeriniz'
};
